import React from 'react';
import { useSelector } from 'react-redux';
import { formatCurrency, formatWithoutCurrency } from '../../helpers/helperFunction';

const white_label_perkeso = process.env.REACT_APP_WHITE_LABEL_PERKESO === 'true';

const LinkedAccountSVG = () => {
  return (
    <div className="account-card-avatar">
      <div className="user-profile">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
        >
          <circle cx="20" cy="20" r="18.5" stroke="url(#paint0_linear_71_4800)" strokeWidth="3" />
          <defs>
            <linearGradient
              id="paint0_linear_71_4800"
              x1="20"
              y1="0"
              x2="20"
              y2="40"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#2D57A8" />
              <stop offset="1" stopColor="#2DA858" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
        <img src={require('../../assets/elfo-icon.png')} className="" alt="Avatar" />
      </div>
    </div>
  );
};

const AccountCard = ({ role, name, totalCredits, availableCredits }) => {
  const { user } = useSelector((state) => state.auth);

  return (
    <div className="account-card" style={{ padding: '15px' }}>
      {/*<div className="account-card-role">*/}
      {/*  <Badge variant="primary">{role}</Badge>*/}
      {/*</div>*/}
      <div className="account-card-bio" style={{ marginBottom: '8px' }}>
        <LinkedAccountSVG />
        <div className="account-card-name">{name}</div>
      </div>
      <div className="account-card-credits">
        {/*<div className="divider-line-vertical" />*/}
        <div className="available-credits">
          <span style={{ fontSize: '18px', lineHeight: '27px', marginBottom: '8px' }}>
            {white_label_perkeso
              ? formatWithoutCurrency(availableCredits, 0, 0)
              : formatCurrency(user?.currency?.iso3, availableCredits, 2)}
          </span>
          <span
            style={{
              fontSize: '13px',
              lineHeight: '18px',
              fontWeight: '400',
              textTransform: 'uppercase',
              color: '#737C8A',
            }}
          >
            Credit Balance
          </span>
        </div>
      </div>
    </div>
  );
};

export default AccountCard;
